import { createContext, useContext, useState } from 'react';

const OfficeContext = createContext();

export function OfficeProvider({ children }) {
  const [office, setOffice] = useState(null);

  return (
    <OfficeContext.Provider value={{ office, setOffice }}>
      {children}
    </OfficeContext.Provider>
  );
}

export function useOffice() {
  return useContext(OfficeContext);
}
